import { Component } from '@verndale/core';

class RtfModal extends Component {
  constructor(el: HTMLElement) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      close: this.el.querySelector('.rtf-modal__close') as HTMLButtonElement
    };
  }

  addListeners() {
    (this.dom.close as HTMLButtonElement).addEventListener('click', this.handleClose.bind(this));
  }

  handleClose() {
    (this.el as HTMLDialogElement).close();
    document.body.classList.remove('no-scroll');
  }
}

export default RtfModal;
